import LoginPage from "../components/Auth/components/login";
import React from "react";
import Footer from "../components/Footer/Footer";
export default function Login() {
  return (
    <div className="">
      
      <LoginPage />
      <Footer/>
    </div>
  );
}

